export const MODEL_ACCURACY_THRESHOLD = 70;
export const MODEL_MAPE_THRESHOLD = 20;
export const MODEL_BUSINESS_ERROR_THRESHOLD = 35;
